import styled from 'styled-components';
import Icon from 'core/svg-sprites/ui/Icon';

export const ButtonStyled = styled.button``;

export const IconStyled = styled(Icon)`
  transform: rotate(90deg);
`;
